import { render, staticRenderFns } from "./TsFilter.vue?vue&type=template&id=c64d7148&scoped=true"
import script from "./TsFilter.vue?vue&type=script&lang=js"
export * from "./TsFilter.vue?vue&type=script&lang=js"
import style0 from "./TsFilter.vue?vue&type=style&index=0&id=c64d7148&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c64d7148",
  null
  
)

export default component.exports